<script setup lang="ts">
import { Hit } from 'instantsearch.js/es/types';
import { computed, PropType } from 'vue';

import routerLinkDelegationMixin from '@/mixins/routerLinkDelegation';

defineOptions({
  mixins: [routerLinkDelegationMixin],
});

export interface MerchandisingBanner {
  banner: string | { desktop: string; mobile: string } | { html: string };
  classes?: string;
  id: string;
  path: string;
  position: number;
  title: string;
}

export type MerchandisingBannerSyntheticHit = MerchandisingBanner &
  Pick<Hit, 'objectID' | '__position'>;

const props = defineProps({
  item: { required: true, type: Object as PropType<MerchandisingBannerSyntheticHit> },
});

const banner = computed(() => props.item.banner);
const cardClass = computed(() => props.item.classes);
const cardId = computed(() => props.item.id);

const htmlBanner = computed(() => typeof banner.value === 'object' && 'html' in banner.value);
const images = computed(() => {
  const bannerImages = [];
  if (typeof banner.value === 'string') {
    bannerImages.push({
      responsiveClasses: '',
      src: banner.value,
    });
  } else if ('desktop' in banner.value && 'mobile' in banner.value) {
    bannerImages.push(
      {
        responsiveClasses: 'visible-xs',
        src: banner.value.mobile,
      },
      {
        responsiveClasses: 'hidden-xs',
        src: banner.value.desktop,
      },
    );
  }
  return bannerImages;
});
</script>

<template>
  <div
    class="product-search-banner-card dynamic-content"
    :class="cardClass"
    :id="cardId"
    @click="delegateLinksToRouter"
  >
    <div v-if="htmlBanner" v-html="item.banner.html" />
    <RouterLink v-else :to="item.path">
      <img
        v-for="image in images"
        :key="image.src"
        :src="image.src"
        :alt="item.title"
        :class="image.responsiveClasses"
        loading="lazy"
      />
    </RouterLink>
  </div>
</template>
